<div class="folder-square-container" [ngClass]="folderSquareData?.style">
  @if (folderSquareData) {
    <div class="content">
      <img [src]="'/public/assets/images/' + folderSquareData.image" [alt]="folderSquareData.title + 'icon'" />
      @if (folderSquareData.title) {
        <h2>{{ folderSquareData.title | translate }}</h2>
      }
      @if (folderSquareData.subtitle) {
        <div>
          @if (folderSquareData.value) {
            <span>{{ folderSquareData.value | translate }}</span>
          }
          <p>{{ folderSquareData.subtitle | translate }}</p>
        </div>
      }
    </div>
  }
</div>

